

import React  , {useEffect} from 'react';
import {Routes , Route} from 'react-router-dom'
// import ToneLoader from './components/common/toneLoader.jsx';
import  './App.css'


import Photos from './components/pages/photosMain.jsx';
import PhotosHome from './components/pages/photosHome/index.jsx'
import PhotosPages from './components/pages/photosPages/index.jsx';
import PhotosSingle from './components/pages/photosSingle/index.jsx';
import PhotosAlbum from './components/pages/photosAlbum/index.jsx';

import PageNotFound from './components/pages/pageNotFound.jsx';
import GptLoader from './components/ads/gptLoader.jsx';
import AdSenseLoader from './components/common/AdSenseLoader.jsx';



const App = ({data}) =>{
            
       
     let isMobile = data?.[1].isMobile || false
     
     

      
         useEffect(() => {
    /* Disable right click */
    const handleContextMenu = (e) => {
      e.preventDefault()
    }

    /* Disable copy, cut, paste */
    const handleCopy = (e) => e.preventDefault()
    const handleCut = (e) => e.preventDefault()
    const handlePaste = (e) => e.preventDefault()

    /* Disable keyboard shortcuts (Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+S, Ctrl+U) */
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['c', 'v', 'x', 's', 'u'].includes(e.key.toLowerCase())
      ) {
        e.preventDefault()
      }
    }

    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('copy', handleCopy)
    document.addEventListener('cut', handleCut)
    document.addEventListener('paste', handlePaste)
    document.addEventListener('keydown', handleKeyDown)

    /* Disable image drag */
    const disableImageDrag = () => {
      document.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false')
      })
    }

    disableImageDrag()

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
      document.removeEventListener('copy', handleCopy)
      document.removeEventListener('cut', handleCut)
      document.removeEventListener('paste', handlePaste)
      document.removeEventListener('keydown', handleKeyDown)
    }
          }, [])


         useEffect(() => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
}, []); 

      

    return(
     
      <main className="App d-flex flex-column align-items-center">
        <GptLoader />
        <AdSenseLoader />
        <Routes>
            <Route path="/" element={<Photos isMobile={isMobile}  />}>
               <Route index element={<PhotosHome data={data}  />} />
                  <Route path='pages/:category' element={<PhotosPages data={data} />} />
                  <Route  path='picture/:type' element={<PhotosAlbum data={data}  />} /> 
                  <Route  path='single/:single' element={<PhotosSingle data={data} />} />
            </Route>
            <Route path="*" element={<PageNotFound />} />
           </Routes>
     
     </main>
    )
}


export default App;